module.exports = __webpack_public_path__ + "static/img/lr.309ccbd8.svg";